import React from "react";
import { useSelector } from "react-redux";

import Button from "@cayuse/shared-react.components.button";
import IconButton from "@cayuse/shared-react.components.icon-button";

import { useDictionary } from "hooks";
import { budgetBuilderSelectors } from "store/selectors";

const ExternalCostShareButtons = (
	{
		isEditing,
		isModified,
		setIsEditing,
		handleReset,
		handleSave,
		addExternalCostShareItem
	}
) => {
	const isLoading = useSelector(budgetBuilderSelectors.isFetching);
	const dictionary = useDictionary("budgetBuilder.buttonLabels");

	const handleCancel = () => {
		handleReset();
		setIsEditing(false);
	};

	const enableEditing = () => setIsEditing(true);

	const cancelButton = () => (
		<Button disabled={!isEditing} onClick={() => handleCancel()} secondary>
			{dictionary.cancel || "Cancel"}
		</Button>
	);

	const editSaveButton = () => isEditing ? (
		<IconButton
			key="save"
			icon="save"
			labelPosition="left"
			disabled={!isModified}
			busy={isLoading}
			onClick={handleSave}
		>
			{dictionary.save || "Save"}
		</IconButton>
	) : (
		<IconButton
			key="edit"
			icon="pencil-alt"
			labelPosition="left"
			onClick={() => enableEditing()}
		>
			{dictionary.edit || "Edit"}
		</IconButton>
	);

	const addCategoryButton = () => (
		<IconButton
			key="add"
			icon="plus"
			labelPosition="left"
			onClick={() => addExternalCostShareItem()}
		>
			{"Add Line Item"}
		</IconButton>
	);


	return ([ cancelButton(), editSaveButton(), addCategoryButton() ]);
};

export default ExternalCostShareButtons;
